import { createFileRoute, redirect } from '@tanstack/react-router';

import { getDefaultPeriod } from '@/features/contract-and-cost/period';

export const Route = createFileRoute(
  '/_staff/payroll/_layout/contract-and-cost/_contract-and-cost/',
)({
  beforeLoad: () => {
    throw redirect({
      to: '/payroll/contract-and-cost/payment/$period',
      params: { period: getDefaultPeriod() },
    });
  },
});
